import { Button, Input } from "@mantine/core";
import { useState, useEffect } from "react";
import { repositoryPos } from "../../../../_base/_const/_constVar";

interface CustomNavigator extends Navigator {
  serial: any;
}

const base64ToUint8Array = (base64: string): Uint8Array => {
  const binaryString = atob(base64);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
};

const useSerial = () => {
  const [port, setPort] = useState<any | null>(null);
  const [isConnectedSerial, setConnectedSerial] = useState<boolean>(false);

  const sleep = (ms: number) =>
    new Promise((resolve) => setTimeout(resolve, ms));

  const writeToPort = async (data: Uint8Array) => {
    if (!port || !port.writable) return;
    try {
      const writer = port.writable.getWriter();
      await writer.write(data);
      await sleep(100);
      writer.releaseLock();
    } catch (err) {
      console.error("Lỗi khi gửi dữ liệu đến cổng serial:", err);
    }
  };

  const openPort = async () => {
    const navi: CustomNavigator = navigator as CustomNavigator;
    if (!navi.serial) {
      console.log("Trình duyệt không hỗ trợ Web Serial API");
      return;
    }
    try {
      const requestedPort = await navi.serial.requestPort();
      await requestedPort.open({
        baudRate: 115200,
        bufferSize: 255,
        dataBits: 8,
        stopBits: 1,
      });
      setPort(requestedPort);
      setConnectedSerial(true);
    } catch (err) {
      console.log(`Lỗi khi kết nối: ${(err as Error).message}`);
    }
  };

  const closePort = async () => {
    if (port) {
      await port.close();
      setPort(null);
      setConnectedSerial(false);
    }
  };

  const show = async (data: Uint8Array) => {
    if (isConnectedSerial) {
      await writeToPort(data);
    }
  };

  useEffect(() => {
    return () => {
      if (port) closePort();
    };
  }, [port]);

  return { isConnectedSerial, openPort, closePort, show };
};

const SerialQRComponent = ({
  isShowQr,
  isSuccess,
  isMoiThanhToan,
  qrInfo,
  price,
  orderNumber,
}: any) => {
  const { isConnectedSerial, openPort, show } = useSerial();
  const [stxText, setStxText] = useState("");

  const handleShowQR = async () => {
    const url = `/api/v1/CreateSellItem/qr-to-byte?qr=${qrInfo}&amount=${price}&note=${orderNumber}&nameBank=HACOM`;
    const getqr = await repositoryPos.get(url);
    if (getqr?.httpStatusCode === 200 && getqr?.data) {
      show(base64ToUint8Array(getqr.data));
      //   await sleep(1000);
      const urlNoti = "/api/v1/CreateSellItem/qr-audito-success?success=false";
      const getNoti = await repositoryPos.get(urlNoti);
      if (getNoti?.httpStatusCode === 200 && getNoti?.data) {
        show(base64ToUint8Array(getNoti.data));
      }
    }
  };

  const handleSuccess = async () => {
    const urlNoti = "/api/v1/CreateSellItem/qr-audito-success?success=true";
    const getqr = await repositoryPos.get(urlNoti);
    if (getqr?.httpStatusCode === 200 && getqr?.data) {
      show(base64ToUint8Array(getqr.data));
    }
  };

  const moiThanhToan = async () => {
    const urlNoti = "/api/v1/CreateSellItem/qr-audito-success?success=false";
    const getqr = await repositoryPos.get(urlNoti);
    if (getqr?.httpStatusCode === 200 && getqr?.data) {
      show(base64ToUint8Array(getqr.data));
    }
  };

  useEffect(() => {
    if (isShowQr) {
      handleShowQR();

      // Gọi moiThanhToan() sau 1 giây
      const timeoutId = setTimeout(() => {
        moiThanhToan();
      }, 1000);

      // Cleanup khi component unmount hoặc isShowQr thay đổi
      return () => clearTimeout(timeoutId);
    }
  }, [isShowQr]);

  useEffect(() => {
    if (isSuccess) {
      handleSuccess();
    }
  }, [isSuccess]);

  return (
    <div>
      <Button onClick={openPort}>Kết nối</Button>
      {/* <Input value={stxText} onChange={(e) => setStxText(e.target.value)} />
      <Button onClick={handleShowQR}>showQR</Button>
      <Button onClick={handleSuccess}>Thành công</Button> */}
    </div>
  );
};

export default SerialQRComponent;
